import {
  useCallback,
  useState,
  type Dispatch,
  type SetStateAction,
} from "react";

export interface CreferenceTransientState {
  dismissAlreadyFocusedHint: () => void;
  handleMemberGlimpseClose: () => void;
  hintAnchorElement: HTMLSpanElement | null;
  isActionPending: boolean;
  isAlreadyFocusedHintVisible: boolean;
  isHovered: boolean;
  isMemberGlimpseVisible: boolean;
  setHintAnchorElement: (element: HTMLSpanElement | null) => void;
  setIsActionPending: Dispatch<SetStateAction<boolean>>;
  setIsHovered: (isHovered: boolean) => void;
  showAlreadyFocusedHint: () => void;
  showMemberGlimpse: () => void;
}

export function useCreferenceTransientState(): CreferenceTransientState {
  const [isActionPending, setIsActionPending] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isMemberGlimpseVisible, setIsMemberGlimpseVisible] = useState(false);
  const [isAlreadyFocusedHintVisible, setIsAlreadyFocusedHintVisible] =
    useState(false);
  const [hintAnchorElement, setHintAnchorElement] =
    useState<HTMLSpanElement | null>(null);
  const showMemberGlimpse = useCallback(
    () => setIsMemberGlimpseVisible(true),
    [setIsMemberGlimpseVisible],
  );
  const handleMemberGlimpseClose = useCallback(
    () => setIsMemberGlimpseVisible(false),
    [setIsMemberGlimpseVisible],
  );
  const showAlreadyFocusedHint = useCallback(
    () => setIsAlreadyFocusedHintVisible(true),
    [setIsAlreadyFocusedHintVisible],
  );
  const dismissAlreadyFocusedHint = useCallback(
    () => setIsAlreadyFocusedHintVisible(false),
    [setIsAlreadyFocusedHintVisible],
  );

  return {
    dismissAlreadyFocusedHint,
    handleMemberGlimpseClose,
    hintAnchorElement,
    isActionPending,
    isAlreadyFocusedHintVisible,
    isHovered,
    isMemberGlimpseVisible,
    setHintAnchorElement,
    setIsActionPending,
    setIsHovered,
    showAlreadyFocusedHint,
    showMemberGlimpse,
  };
}
